// src/Pages/Skills.js

import React from "react";
import { DiJava, DiNodejs } from "react-icons/di";
import { BsFiletypeJson } from "react-icons/bs";
import {
  SiPython,
  SiJavascript,
  SiTypescript,
  SiReact,
  SiNextdotjs,
  SiRedux,
  SiGraphql,
  SiTailwindcss,
  SiBootstrap,
  SiHtml5,
  SiCss3,
  SiSpringboot,
  SiMongodb,
  SiDocker,
  SiRedis,
  SiGit,
  SiGithubactions,
  SiJenkins,
  SiFirebase,
  SiWebpack,
  SiAmazonwebservices,
  SiKubernetes,
  SiHeroku,
} from "react-icons/si";

const iconMap = {
  // Programming Languages
  Python: SiPython,
  Java: DiJava,

  // Front-End Technologies
  "JavaScript (ES6)": SiJavascript,
  Typescript: SiTypescript,
  "React.js": SiReact,
  "Next.js": SiNextdotjs,
  Redux: SiRedux,
  GraphQL: SiGraphql,
  "Tailwind CSS": SiTailwindcss,
  Bootstrap: SiBootstrap,
  HTML5: SiHtml5,
  CSS3: SiCss3,
  JSON: BsFiletypeJson,

  // Back-End Technologies
  "Node.js": DiNodejs,
  "Spring Boot": SiSpringboot,
  "NoSQL (MongoDB)": SiMongodb,
  Redis: SiRedis,

  // Tools
  Git: SiGit,
  "GitHub Actions": SiGithubactions,
  Jenkins: SiJenkins,
  Firebase: SiFirebase,
  Webpack: SiWebpack,

  // Cloud Technologies
  AWS: SiAmazonwebservices,
  Docker: SiDocker,
  Kubernetes: SiKubernetes,
  Heroku: SiHeroku,
};

export const skillsData = [
  {
    category: "Programming Languages",
    skills: ["Python", "Java", "JavaScript (ES6)", "Typescript"],
  },
  {
    category: "Front-End Technologies",
    skills: [
      "React.js",
      "Next.js",
      "Redux",
      "GraphQL",
      "Tailwind CSS",
      "Bootstrap",
      "HTML5",
      "CSS3",
      "JSON",
      "JavaScript (ES6)",
      "Typescript",
    ],
  },
  {
    category: "Back-End Technologies",
    skills: [
      "Node.js",
      "Spring Boot",
      "NoSQL (MongoDB)",
      "Redis",
    ],
  },
  {
    category: "Methodologies",
    skills: ["Agile (SCRUM)", "TDD"],
  },
  {
    category: "Tools",
    skills: [
      "Git",
      "GitHub Actions",
      "Jenkins",
      "Firebase",
      "Webpack",
    ],
  },
  {
    category: "Cloud Technologies",
    skills: ["AWS", "Docker", "Kubernetes", "Heroku"],
  },
];

export default function Skills() {
  return (
    <div className="flex flex-wrap justify-center gap-4 mb-12">
      {skillsData.map((section, idx) => (
        <div key={idx} className="mb-4 w-full">
          <h3 className="mb-2 text-lg font-bold text-black dark:text-slate-100">
            {section.category}
          </h3>
          <div className="flex flex-wrap gap-2">
            {section.skills.map((skill) => {
              const Icon = iconMap[skill];
              return (
                <span
                  key={skill}
                  className="flex items-center gap-2 rounded-xl bg-slate-100 px-4 py-2 text-base font-semibold text-[#213448] dark:bg-slate-900 dark:text-slate-100"
                >
                  {Icon && (
                    <span className="text-gray-500 transition hover:text-orange-500 dark:text-slate-400 dark:hover:text-[#F59E0B]">
                      <Icon size={20} title={skill} />
                    </span>
                  )}
                  {skill}
                </span>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
